import { render, staticRenderFns } from "./UserSearch.vue?vue&type=template&id=3bbf221c&scoped=true"
import script from "./UserSearch.vue?vue&type=script&lang=js"
export * from "./UserSearch.vue?vue&type=script&lang=js"
import style0 from "./UserSearch.vue?vue&type=style&index=0&id=3bbf221c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbf221c",
  null
  
)

export default component.exports